import React from 'react'

interface ClipboardProps {
  className?: string
}

const Clipboard: React.FC<ClipboardProps> = ({ className }: ClipboardProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6589 3.29533C18.9704 3.61609 20.75 5.60022 20.75 8V15.633C20.75 16.7252 20.75 17.5906 20.693 18.2883C20.6347 19.0017 20.5131 19.6053 20.2323 20.1565C19.7769 21.0502 19.0502 21.7769 18.1565 22.2323C17.6053 22.5131 17.0017 22.6347 16.2883 22.693C15.5906 22.75 14.7252 22.75 13.633 22.75H10.367C9.27484 22.75 8.40935 22.75 7.71173 22.693C6.99834 22.6347 6.39472 22.5131 5.84355 22.2323C4.94978 21.7769 4.22312 21.0502 3.76772 20.1565C3.48688 19.6053 3.36527 19.0017 3.30699 18.2883C3.24999 17.5906 3.24999 16.7252 3.25 15.633V8C3.25 5.60022 5.02961 3.61609 7.34112 3.29533C7.65233 2.11796 8.7248 1.25 10 1.25H14C15.2752 1.25 16.3477 2.11796 16.6589 3.29533ZM8.75 4C8.75 3.30964 9.30964 2.75 10 2.75H14C14.6904 2.75 15.25 3.30964 15.25 4C15.25 4.69036 14.6904 5.25 14 5.25H10C9.30964 5.25 8.75 4.69036 8.75 4ZM8.25 11C8.25 10.5858 8.58579 10.25 9 10.25H15C15.4142 10.25 15.75 10.5858 15.75 11C15.75 11.4142 15.4142 11.75 15 11.75H9C8.58579 11.75 8.25 11.4142 8.25 11ZM8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H13C13.4142 14.25 13.75 14.5858 13.75 15C13.75 15.4142 13.4142 15.75 13 15.75H9C8.58579 15.75 8.25 15.4142 8.25 15Z"
      fill="#252324"
    />
  </svg>
)

export default Clipboard
